import Queue from "nq-js";

class LiveQueryUseCase {
  execute(query, type) {
    return Queue.LiveQuery.subscribe(query, type);
  }
}

export default LiveQueryUseCase;
